export default "__VITE_ASSET__DIFB2AmE__"